import { render, staticRenderFns } from "./afr.vue?vue&type=template&id=3b82b666"
import script from "./afr.vue?vue&type=script&lang=js"
export * from "./afr.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports